import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type SidebarPulseIndicatorProps = {
  count: number;
  color: "yellow" | "blue";
  tooltip: string;
};

const colorMap = {
  yellow: {
    ping: "bg-yellow-400",
    solid: "bg-yellow-500",
  },
  blue: {
    ping: "bg-blue-400",
    solid: "bg-blue-500",
  },
};

export function SidebarPulseIndicator({
  count,
  color,
  tooltip,
}: SidebarPulseIndicatorProps) {
  if (count === 0) return null;

  const colors = colorMap[color];

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="relative ml-auto flex size-5 items-center justify-center">
          <span
            className={`absolute inline-flex size-full animate-ping rounded-full ${colors.ping} opacity-75`}
          />
          <span
            className={`relative flex size-5 items-center justify-center rounded-full ${colors.solid} text-xs font-bold text-white`}
          >
            {count}
          </span>
        </span>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
